export default __webpack_public_path__ + "static/media/slider-courier-mask.03ddfa8c.png";